import { tv } from "../../variants/tv.js";
const chatBubbleVariants = tv({
    slots: {
        wrapperSlot: 'flex flex-col gap-4',
        containerSlot: 'relative w-fit max-w-full text-pretty',
        contentSlot: 'text-body1 wrap-anywhere relative break-words antialiased',
        responseIconSlot: 'absolute left-0 top-0 -translate-x-0 -translate-y-6 md:-translate-y-4',
        footerSlot: 'text-body2 flex gap-5 antialiased'
    },
    variants: {
        role: {
            user: {
                wrapperSlot: 'items-end',
                containerSlot: 'md:max-w-3/4 bg-userBubble flex justify-end rounded-l-2xl rounded-br-md rounded-tr-2xl p-3',
                contentSlot: 'text-penny-1',
                footerSlot: 'text-penny-10 justify-end pr-3'
            },
            response: {
                containerSlot: 'bg-responseBubble inset-shadow-responseBubble justify-self-start rounded-l-md rounded-r-2xl py-3 pl-3 pr-3 md:pl-10 md:pr-4',
                contentSlot: 'text-penny-13',
                footerSlot: 'text-penny-10 justify-start pl-3 md:pl-10'
            },
            responseBold: {
                containerSlot: 'bg-responseBubble-bold inset-shadow-responseBubble-bold justify-self-start rounded-l-md rounded-r-2xl py-3 pl-3 pr-3 md:pl-10 md:pr-4',
                contentSlot: 'text-penny-1',
                footerSlot: 'text-pennyAccents-3 justify-start pl-3 md:pl-10'
            }
        }
    },
    defaultVariants: {
        role: 'user'
    }
});
export { chatBubbleVariants };
